export class EnableFlash {
	constructor() {
		this.arrowContainer = jQuery(".arrow-container");
		this.popupCloseBtn = jQuery(".enable_flash_chrome_instructions_popup .pop-close-btn")
		this.popupThumbnails = jQuery('.enable_flash_chrome_instructions_popup .screenshot-thumbnail')
		this.enableFlash = jQuery("#enable-flash")
		this.attachListeners();
	}

	attachListeners() {
		// activate bouncing arrow
    if (swfobject && swfobject.hasFlashPlayerVersion('1')) {
      jQuery(".arrow-container").hide();
		}

		// lauch enable flash instructions popup
		jQuery(".chrome .screenshot-thumbnail").on("click", function (e) {
			var slideNumber = jQuery(this).data('slide');
			//kill scrolling
			jQuery('body').addClass("no-scroll");
			//show enable flash chrome instructions popup
			jQuery('.enable_flash_chrome_instructions_popup').addClass("show");
			// init the slider
			jQuery('.instruction-steps-slider').slick({
				arrows: false,
				initialSlide: slideNumber
			});

		});

		let that = this;

		this.enableFlash.on("click", function () {
			that.showAttentionArrow();
		});

		//handle popup close button
		this.popupCloseBtn.on("click", function () {
			//restore scrolling
			jQuery('body').removeClass("no-scroll");
			//hide enable flash chrome instructions popup
			jQuery('.enable_flash_chrome_instructions_popup').removeClass("show");
			// destroy the slider
			jQuery('.instruction-steps-slider').slick('unslick');
		});

		// listen to clicks on popup thumbnail btns
		this.popupThumbnails.on("click", function (e) {
			var slideNumber = jQuery(this).data('slide');
			jQuery('.instruction-steps-slider').slick('slickGoTo', slideNumber);
		});
	}

	showAttentionArrow() {
    let that = this;
    if (!this.arrowContainer.hasClass("show")) {
      this.arrowContainer.addClass("show");
      this.arrowContainer.show();
      setTimeout(function () {
        var c = that.arrowContainer;
        that.arrowContainer.fadeOut(3000, function () {
          c.removeClass("show");
        });
      }, 4000);
    }
  }

	static setup() {
		return new EnableFlash()
	}
}